import React from 'react'
import "./courseResult.scss";
import oneStar from 'assets/credits/una_estrellas.svg';
import twoStar from 'assets/credits/dos_estrellas.svg';
import threeStar from 'assets/credits/tres_estrellas.svg';
import arrowCoolDown from 'assets/credits/arrow_cool_down.svg';

interface CourseResultProps {
  punctuation: number;
  setIsResetQuiz: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFinished: React.Dispatch<React.SetStateAction<boolean>>;

}
const CourseResult: React.FC<CourseResultProps> = ({ punctuation, setIsFinished }) => {
  const resetQuiz = () => {
    setIsFinished(false);
  }
  return (
    <div className='containerResult'>
      <div className="containerResult__header">
        <h2>Resultado</h2>
      </div>
      <div className="containerResult__body">
        <div className='containerResult__body__message'>
          <h3>{punctuation > 67 ? "¡Genial!" : "¡Puedes mejorar!"}</h3>
          <p>{
            punctuation > 67 ?
            <>
              Ahora estás listo para manejar tus créditos como un verdadero pro.
              <br />
              Solicita tu crédito sin contratiempos, porque ya superaste este requisito.
            </>
              :
              "No te preocupes, incluso los mejores necesitan repasar de vez en cuando. Dale otra oportunidad a los módulos y luego haz la prueba de nuevo."
          }</p>
          {punctuation >= 67 && <p>¡Recuerda que puedes volver a ver los videos en cualquier momento!</p>}
        </div>
        <div className='containerResult__body__punctuation'>
          <img src={punctuation > 67 ? threeStar : punctuation >= 33 ? twoStar : oneStar} />
          <div>
            <span>{punctuation}</span>
            <span>
              <p>Tu puntaje</p>
              <p>Puntaje máximo 100</p>
            </span>
          </div>
          {punctuation <= 67 && (
            <button
              onClick={()=>{
                if (punctuation <= 67) {
                  resetQuiz();
                }
              }}
            >
              Volver a hacer la prueba
            </button>
          )}
        </div>
      </div>
      {
        punctuation >= 67 &&
        <div className="containerResult__footer">
          <img src={arrowCoolDown} />
          <h2>¿Listo para dar el siguiente paso hacia tu futuro financiero?</h2>
          <p>Una vez que tengas la aprobación y desembolso de tu crédito, regresa a esta plataforma y participa en los retos de nuestra Mentoría Financiera Comfama.</p>
          <p>¡Cada mes, podrías ser el ganador de 50 mil pesos para abonar a tu crédito educativo!</p>
        </div>
      }
    </div>
  )
}

export default CourseResult
